import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  swiftPayments: 'Swift Payments',
  proccesingPayment: 'Payments Sent',
  bulkPayments: 'Bulk Payments',
  rejectPayment: 'Do you like to reject the payment to client?',
  rejectReason: 'Rejected reason',
  templatesExcel: 'Format: Excel',
  InvoiceExport: 'Receipt Export',
  generateInvoiceDate: 'Generate receipts by dates',
  haveGeneratedReceipts: 'You have generated your receipts',
  theReceiptsSentMail: 'The receipts will be sent to your user email.',
  export: 'Export',
  pyDownload: 'Download template',
  pyDownloadFileType: '1. Choose the file of the country to send the payments',
  pyDownloadFileUpload: '2. Upload your file to process your payments',
  pyDownloadVouchers: 'Download your receipts',
  pyMyFiles: '3.File history',
  pyClickToAdd: 'Click to add your file',
  pyOr: 'or',
  pyDragAndDrop: 'Drag and drop the file here',
  pyNoData: 'There is no data to download',
  pyUploadFiles: 'Proccess payments',
  paymentBlockedMessage:
    'For the moment, it is not possible to transfer to this destination. {{reason}}',
  paymentBlockedChinaReason: '',
  payOutUSDUSD: 'This USD to USD payment has a fee of USD $12.50',
  payOutEUREUR: 'This EUR to EUR payment has a fee of 1.5%',
  paymentChinaWarning:
    'Please select MXN as the origin currency for beneficiaries in China. It is not possible to send transfers from (USD, COP, GBP, EUR) to (USD or CNY) in China.',
  paymentBlockedDOReason:
    'For the moment, it is not possible to transfer to República Dominicana',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const PAYABLES_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    swiftPayments: 'Pagos Swift',
    proccesingPayment: 'Envío de pagos',
    bulkPayments: 'Pagos Masivos',
    rejectPayment: '¿Desea rechazar el cobro a client?',
    rejectReason: 'Motivo de rechazo',
    templatesExcel: 'Formato: Excel',
    InvoiceExport: 'Exportar Comprobantes',
    generateInvoiceDate: 'Generar comprobantes por fechas',
    haveGeneratedReceipts: 'Haz generado tus comprobantes!',
    theReceiptsSentMail:
      'Los comprobantes serán enviados a tu correo de usuario.',
    export: 'Exportar',
    pyDownload: 'Descargar plantilla',
    pyDownloadFileType: '1. Escoge el archivo del país a enviar los pagos',
    pyDownloadFileUpload: '2. Sube tu archivo para procesar tus pagos',
    pyDownloadVouchers: 'Descarga tus comprobantes',
    pyMyFiles: '3. Historial de archivos',
    pyClickToAdd: 'Haz click para agregar su archivo',
    pyOr: 'ó',
    pyDragAndDrop: 'Arrastra y suelta el archivo aquí',
    pyNoData: 'No hay información para descargar',
    pyUploadFiles: 'Procesar pagos',
    paymentBlockedMessage:
      'Por el momento, no es posible transferir a este destino. {{reason}}',
    paymentBlockedChinaReason: '',
    payOutUSDUSD: 'Este pago de USD a USD tiene un fee de USD $12.50',
    payOutEUREUR: 'Este pago de EUR a EUR tiene un fee de 1.5%',
    paymentChinaWarning:
      'Por favor seleccione MXN como moneda de origen para beneficiarios en China. Actualmente no es posible enviar transferencias desde (USD, COP, GBP, EUR) hacia (USD o CNY) a China.',
    paymentBlockedDOReason:
      'Por el momento, no es posible transferir a República Dominicana',
  },
};

export default PAYABLES_LANGUAGE_LABELS;
